import makeStore from '../../utils/localstore'

export const LOCALSTORAGE_REDIRECT_FLASH = 'redirect-flash';

export const { get: getFlash, set: setFlash, reset: resetFlash } = makeStore(LOCALSTORAGE_REDIRECT_FLASH);
